module.exports = __webpack_public_path__ + "img/CCS_logo_RGB_horizontal-color.f3f9f517.png";